export type BrandGroupPublicationModel = {
  brand_group_id: number,
  cache_key: number,
  id: number,
  notes?: string,
  publication_id: number,
}

const state = {
  brand_group_id: undefined,
  id: null,
  publication_id: undefined,
}

export const requiredFields = [
  { key: 'brand_group_id' },
  { key: 'publication_id' },
]

export default state
